import { css } from 'styled-components';

import { pxToRem } from 'utils/convert';
import { colors, heading2 } from 'ui/theme';
import { AVATAR_SIZES, AVATAR_COLORS } from './constants';

/**
 * These variants are determined by https://zeroheight.com/3fe730a39/p/71e1a7-avatars
 */
export const SIZE_STYLES = {
  [AVATAR_SIZES.SMALL]: css({
    height: pxToRem(24),
    width: pxToRem(24),
  }),
  [AVATAR_SIZES.MEDIUM]: css({
    height: pxToRem(32),
    width: pxToRem(32),
  }),
  [AVATAR_SIZES.LARGE]: css({
    height: pxToRem(40),
    width: pxToRem(40),
  }),
  [AVATAR_SIZES.XLARGE]: css({
    ...heading2,
    color: colors.white,
    height: pxToRem(64),
    width: pxToRem(64),
  }),
};

export const COLOR_STYLES = {
  [AVATAR_COLORS.BLUE]: colors.cyan100,
  [AVATAR_COLORS.GREEN]: colors.green100,
  [AVATAR_COLORS.ORANGE]: colors.salmon100,
  [AVATAR_COLORS.PURPLE]: colors.purple100,
  [AVATAR_COLORS.RED]: colors.red100,
  [AVATAR_COLORS.GREY]: colors.grey25,
};
